import { Avatar, Box, Card, CardContent,Typography } from "@mui/material";
import PropTypes from 'prop-types'

interface MiniAccountProps {
    image: string,
    name: string,
    email: string,
}

const MiniAccount = (props: MiniAccountProps) => {

    const {image,name,email} = props


    return (
        <Card>

            <CardContent>
                <Box sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Avatar
                        src={image}
                        sx={{
                            height: 80,
                            mb: 2,
                            width: 80
                          }}
                    />

                    <Typography
                        gutterBottom
                        variant="h5"
                    >
                        {name}
                    </Typography>

                    <Typography color='text.secondary' variant="body2">
                        {email}
                    </Typography>

                </Box>
            </CardContent>

        </Card>
    )

}


MiniAccount.propType = {
    name: PropTypes.string,
    image: PropTypes.string,
    email: PropTypes.string
}


export default MiniAccount;